import {register} from '../modules/eventMap';
import {kuiset} from '../utils/kuiset';

const toggler = (el, isDisabled) => {
    const {toggleDisabledSelector} = kuiset(el);
    const fields = [...document.querySelectorAll(toggleDisabledSelector)];
    fields.forEach((field) => {
        field.disabled = isDisabled;
    });
};

const toggleOn = (el) => toggler(el, true);
const toggleOff = (el) => toggler(el, false);
const toggle = (el) => toggler(el, !el.checked);

const inputTypePassword = (el) => {
    const toggleParams = kuiset(el);
    const nextState = toggleParams.toggleState === 'On' ? 'Off' : 'On';
    const fields = [...document.querySelectorAll(toggleParams.toggleSelector)];

    fields.forEach((field) => {
        field.type = toggleParams[`toggleAttribute${nextState}Value`];
    });
    el.setAttribute('aria-label', toggleParams[`toggle${nextState}Text`]);
    el.setAttribute('kui-toggle-state', nextState);
};

const toggleDisabled = () => {
    register('toggleDisabled', {
        toggle,
        toggleOff,
        toggleOn,
        inputTypePassword
    });
};

export {toggleDisabled};
